import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTIONS_BY_CAMPAIGN_BY_DATE = gql`
  query campaignOrderTransactionsByCampaignByDate($campaignId: ID!) {
    transactionByCampaignByDates(
      where: { campaignTransaction: { id: $campaignId } }
      orderBy: date_ASC
    ) {
      id
      date
      transactions
      revenue
      spend
      impressions
      customers
      uniqueIdentifiers
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTIONS_BY_CAMPAIGN_BY_DATE;
